import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { XEventService } from './x-event.service';
import { ScriptService } from './script.service';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root'
})
export class SocketService extends XEventService {
    private readonly host: string = environment.ws.u
    private socket: any;
    private qu: any[] = [];
    private reconn: boolean = false;

    constructor(
        private ss: ScriptService,
    ) {
        super();
        this.connect();
    }

    connect(): void {
        if (this.isSupported()) {
            this.socket = new WebSocket(this.host);
            this.socket.binaryType = 'arraybuffer';
            this.socket.addEventListener('open', () => {
                while (this.qu.length) {
                    this.send(this.qu.shift());
                }
                if (this.reconn) {
                    this.reconn = false;
                    this.triggerEvent({name: '$reconnected', data: this});
                }
                this.triggerEvent({name: '$connected', data: this});
            });
            this.socket.addEventListener('close', () => this.disconnected());
            this.socket.addEventListener('error', (error: any) => {
                console.error(error);
            });
            this.socket.addEventListener('message', (message: any) => {
                this.parseMessage(message);
            });
        }
    }

    emit(chanel: string, message: any): void {
        if (this.isSupported()) {
            const msg = JSON.stringify([chanel, message]);
            if (this.isConnected()) {
                this.send(msg);
            } else {
                this.qu.push(msg);
            }
        }
    }

    on(eventName: string): Observable<any> {
        if ((eventName === '$connected') && this.isConnected()) {
            return this.events.pipe(filter(event => event.name === eventName), map(event => event.data), startWith(this));
        }
        return this.events.pipe(filter(event => event.name === eventName), map(event => event.data));
    }

    private send(data: string): void {
        this.socket && this.socket.send(data);
    }

    private parseMessage(ev: any): void {
        const cb = () => {
            var raw = (globalThis as { [key: string]: any })['pako'].ungzip(ev.data, {to: 'string'});
            try {
                const message = JSON.parse(raw);
                this.triggerEvent({name: message[0], data: message[1]});
            } catch (e) {
                console.warn(e);
            }
        };
        if ((globalThis as { [key: string]: any })['pako']) {
            cb();
        } else {
            this.ss.load('pako_inflate.min.js').then(() => cb());
        }
    }

    private disconnected(): void {
        this.reconn = true;
        setTimeout(() => {
            this.connect();
        }, 10000);
    }

    isSupported(): boolean {
        return !!globalThis.WebSocket;
    }

    isConnected(): boolean {
        return this.socket?.readyState === WebSocket.OPEN;
    }
}
